import { render } from "./tareaCreate.vue?vue&type=template&id=e4167918"
import script from "./tareaCreate.vue?vue&type=script&lang=js"
export * from "./tareaCreate.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__